import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterFormService} from '../../views/filter_form/filter_form.service';
import {BaseComponent} from '../../views/base.component';
import {TranslateService} from '../../translate';
import {EventsService} from '../../lib/EventsService';
import {ModalService} from '../../views/modal/base_modal.component';
import {HelperService} from '../../lib/helper.service';
import {NgbTabChangeEvent} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import * as qs from 'qs';
import { BillingService2 } from "../billing.service";

@Component({
  selector: 'app-ones',
  templateUrl: './ones.component.html',
})
export class OnesComponent extends BaseComponent implements OnInit {
	invoices = [];
	
	tableLoader = false;
	
	total = 0;
	
	form: FormGroup = new FormGroup({
		invoiceNumber: new FormControl('')
	});
	
	addFilterParams = {
		paidType: 'paid'
	};
	
	constructor(
		public translate: TranslateService,
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public modalService: ModalService,
		public helper: HelperService,
		private router: Router,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}
	
	
	ngOnInit() {
		super.ngOnInit();
		
		const me = this;
		
		me.form.get('invoiceNumber').setValue(
			me.filter.filterParams.invoiceNumber
		);
		
		me.form.get('invoiceNumber').valueChanges.pipe(
			debounceTime(1000),
		).subscribe(async invoiceNumber => {
			me.filter.filterParams.page = 1;
			
			const _invoiceNumber = invoiceNumber.trim();
			if (_invoiceNumber === '') {
				delete me.filter.filterParams.invoiceNumber;
			} else {
				me.filter.filterParams.invoiceNumber = parseInt(_invoiceNumber, 10);
			}
			
			const
				params = me.filter.getApplyFilters(me.filter.filterParams),
				url    = me.router.url.split('?')[0];
			
			const paramsAsStr = qs.stringify(params, {encode: false});
			await me.router.navigateByUrl(`${url}?${paramsAsStr}`, {relativeTo: me.activatedRoute});
		});
	}
	
	
	getPageSymbol(page: number): string {
		return this.pagination.pages[page - 1];
	}
	
	
	async getData() {
		const me = this;
		
		await me.getPagination();
		await me.getStats();
	}
	
	
	async beforeChange($event: NgbTabChangeEvent) {
		const me = this;
		
		me.filter.filterParams.page     = 1;
		me.filter.filterParams.paidType = $event.nextId.replace('tab-', '');
		
		const
			params = me.filter.getApplyFilters(me.filter.filterParams),
			url    = me.router.url.split('?')[0];
		
		const paramsAsStr = qs.stringify(params, {encode: false});
		await me.router.navigateByUrl(`${url}?${paramsAsStr}`, {relativeTo: me.activatedRoute});
	}
	
	
	async pageChange() {
		const me = this;
		
		me.filter.filterParams.page = me.pagination.page;
		
		const
			params = me.filter.getApplyFilters(me.filter.filterParams),
			url    = me.router.url.split('?')[0];
		
		const paramsAsStr = qs.stringify(params, {encode: false});
		await me.router.navigateByUrl(`${url}?${paramsAsStr}`, {relativeTo: me.activatedRoute});
	}
	
	
	async getPagination() {
		const me = this;
		
		const pagination = await this.service2.ones.pagination(
			me.filter.filterParams
		).toPromise();
		me.pagination.fill(pagination);
	}
	
	
	async getStats() {
		const me = this;
		
		me.invoices = [];
		me.total = 0;
		
		me.tableLoader = true;
		
		const { stats } = await me.service2.ones.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.invoices = stats;
		me.tableLoader = false;
		
		me.total = (me.invoices.reduce((total, invoice) => {
			if ( ! invoice.error) {
				total += invoice.amount;
			}
			return total;
		}, 0)).toFixed(2);
	}
}
